import { Component } from '@angular/core';

import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';

import { SearchService } from '../../search/services/search.service';

/**
 * Renders a searchable result field grid cell.
 */
@Component({
	selector: 'grid-searchable-cell-renderer',
	templateUrl: './grid-searchable-cell-renderer.component.html',
	styleUrl: './grid-searchable-cell-renderer.component.css'
})
export class GridSearchableCellRendererComponent implements ICellRendererAngularComp {
	context: any; // Passed in through the parent gridOptions 
	value: any;
	field: string = '';

	constructor(
		private searchService: SearchService
	) { }

	agInit(params: ICellRendererParams): void {
		this.refresh(params);
	}

	refresh(params: ICellRendererParams): boolean {
		this.context = params.context;
		this.value = params.value || [];
		this.field = params?.colDef?.field || '';

		return true;
	}

	isValidFieldCollectionValue(field: string, value: string): boolean {
		return this.searchService.isValidCollectionValue(field, value);
	}

	/**
	 * Executes a search using the field and value.
	 */
	resultFieldSearch(field: string, value: string): void {
		console.log(`Searching for: ${field}, with value: ${value}`);

		let payload = {
			field: field,
			value: value
		};
		this.searchService.broadcastSearchResultFieldEvent(payload);
	}
}
